module.exports = __webpack_public_path__ + "static/media/3_imker_tessin.c9781b77.jpeg";